import { Box, Grid, Skeleton, Stack } from '@mui/material';

const CourseCardSkeleton = () => (
  <Box
    sx={{
      backgroundColor: '#fff',
      border: '1px solid #E0E0E0',
      borderRadius: '12px',
      padding: '16px',
    }}
  >
    <Stack direction='row' spacing={2} alignItems='flex-start'>
      <Skeleton
        variant='rounded'
        width={80}
        height={60}
        sx={{ borderRadius: '8px', flexShrink: 0 }}
      />
      <Stack flex={1} spacing={0.5}>
        <Skeleton variant='text' width='70%' height={22} />
        <Skeleton variant='text' width='50%' height={18} />
        <Stack direction='row' spacing={1} alignItems='center' mt={0.5}>
          <Skeleton variant='rounded' width={80} height={24} sx={{ borderRadius: '12px' }} />
          <Skeleton variant='text' width={60} height={18} />
        </Stack>
      </Stack>
      <Skeleton variant='circular' width={24} height={24} sx={{ flexShrink: 0 }} />
    </Stack>
  </Box>
);

export const CourseDetailSkeleton = () => {
  return (
    <Box>
      <Grid
        container
        spacing={6}
        sx={{ backgroundColor: 'white', borderRadius: '12px', padding: '20px' }}
      >
        {/* Left Column - Main Content */}
        <Grid item xs={12} lg={8}>
          <Stack spacing={3}>
            {/* Learning Path chip */}
            <Skeleton variant='rounded' width={120} height={32} sx={{ borderRadius: '16px' }} />

            {/* Title */}
            <Skeleton variant='text' width='60%' height={36} />

            {/* Faculty name */}
            <Skeleton variant='text' width={180} height={20} />

            {/* Star rating */}
            <Stack direction='row' spacing={0.5}>
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton key={index} variant='circular' width={20} height={20} />
              ))}
            </Stack>

            {/* Description heading */}
            <Skeleton variant='text' width={100} height={24} sx={{ mt: 2 }} />

            {/* Description text */}
            <Stack spacing={0.5}>
              <Skeleton variant='text' width='100%' height={18} />
              <Skeleton variant='text' width='100%' height={18} />
              <Skeleton variant='text' width='85%' height={18} />
              <Skeleton variant='text' width={80} height={18} />
            </Stack>

            {/* Course content heading */}
            <Skeleton variant='text' width={140} height={24} sx={{ mt: 2 }} />

            {/* Course cards */}
            <Stack spacing={2}>
              <CourseCardSkeleton />
              <CourseCardSkeleton />
              <CourseCardSkeleton />
            </Stack>
          </Stack>
        </Grid>

        {/* Right Column - Sidebar */}
        <Grid item xs={12} lg={4}>
          <Stack spacing={2}>
            <Box>
              {/* Thumbnail image */}
              <Skeleton
                variant='rounded'
                width='100%'
                height={180}
                sx={{ borderRadius: '12px', mb: 2 }}
              />

              {/* Status chip */}
              <Skeleton
                variant='rounded'
                width={100}
                height={32}
                sx={{ borderRadius: '16px', mb: 2 }}
              />

              {/* Progress bar */}
              <Skeleton
                variant='rounded'
                width='100%'
                height={8}
                sx={{ borderRadius: '4px', my: 1 }}
              />

              {/* Last activity date */}
              <Skeleton variant='text' width={180} height={18} sx={{ mt: 1 }} />

              {/* Due date */}
              <Skeleton variant='text' width={180} height={18} sx={{ mt: 1 }} />

              {/* Resume button */}
              <Skeleton
                variant='rounded'
                width='100%'
                height={48}
                sx={{ borderRadius: '24px', mt: 3 }}
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};
